import { createStore, applyMiddleware } from 'redux';
import thunk from 'redux-thunk';

import rootReducer from 'rebook/mybook/reducers';


export default function configureStore(state = {}) {
  const additionalReducerFn = window && window.__REDUX_DEVTOOLS_EXTENSION__ && window.__REDUX_DEVTOOLS_EXTENSION__();
  // initialize store with server provided data
  const initialState = (window && window.__INITIAL_STATE__) ? window.__INITIAL_STATE__ : state;

  return applyMiddleware(thunk)(createStore)(rootReducer, initialState, additionalReducerFn);
}
